import {Button, Space} from "antd";
import {
  StyledMediaLogsWrapper,
  StyledPublicProfileOfferingDescriptionWrapper,
} from "../../../../public-profile/offering/product-details/description/description.style";
import {FileOutlined} from "@ant-design/icons";
import {CustomerPurchaseAsset} from "../../../../../react-query-hooks/products";
import {StyledContentListItem} from "../../../product-form/content-upload/content-upload.style";

type TMainProductDetails = {
  assets: CustomerPurchaseAsset[];
  productDescription: string;
  /** The product's redirect link, when the purchase ships one. */
  redirectUrl?: string | null;
};

/** Links stored without a scheme still have to resolve as absolute URLs. */
function toExternalLink(url: string) {
  return url.startsWith("http") ? url : `//${url}`;
}

export function MainProductDetails({
  assets,
  productDescription,
  redirectUrl,
}: TMainProductDetails) {
  function handleFileDownload(url: string, fileName: string) {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  }
  return (
    <StyledPublicProfileOfferingDescriptionWrapper>
      <Space
        direction="vertical"
        size={24}
        style={{
          display: "flex",
        }}
      >
        <div>
          {/* <h2 className="content-title">About this product</h2> */}
          <div
            className="content-description"
            dangerouslySetInnerHTML={{__html: productDescription}}
          />
        </div>
        {redirectUrl && (
          <div>
            <p>
              Your purchase includes a link:{" "}
              <a
                href={toExternalLink(redirectUrl)}
                target="_blank"
                rel="noopener noreferrer"
                style={{fontWeight: 600, textDecoration: "underline"}}
              >
                {redirectUrl}
              </a>
            </p>
          </div>
        )}
        <div>
          <StyledMediaLogsWrapper>
            <Space size={16} direction="vertical" style={{display: "flex"}}>
              <h2 className="content-title">Content</h2>

              <Space direction="vertical" size={12} style={{display: "flex"}}>
                {assets.length < 1 ? (
                  <>
                    <p>No content available</p>
                  </>
                ) : (
                  assets.map((item) => (
                    <StyledContentListItem key={item.id}>
                      <div className="content-list-item-info">
                        <div style={{display: "flex", gap: "1.2rem"}}>
                          <FileOutlined className="content-list-item-file-icon" />
                          <span
                            className="content-list-item-name"
                            style={{fontWeight: "600", color: "#1C1726"}}
                          >
                            {`${item.fileName} ${item.fileType}. ${item.fileSize}`}
                          </span>
                        </div>
                      </div>
                      <div>
                        <Button
                          onClick={() => handleFileDownload(item.mediaUrl, item.fileName)}
                          size="small"
                          shape="circle"
                          type="link"
                        >
                          <span style={{textDecoration: "underline"}}>Download</span>
                        </Button>
                      </div>
                    </StyledContentListItem>
                  ))
                )}
              </Space>
            </Space>
          </StyledMediaLogsWrapper>
        </div>
      </Space>
    </StyledPublicProfileOfferingDescriptionWrapper>
  );
}
